<template>
  <form v-on:submit="save">
    <div class="card card-info" v-if="state==='edit'">
      <div class="card-header with-border">
        <h3 class="card-title">Course Question</h3>
      </div>
      <div class="card-body" style="padding-right: 3%; padding-left: 3%">
        <div class="row">
          <div class="col-md-2 ">
            <label>Code</label>
            <input type="text" class="form-control" required maxlength="5" v-model="course.Code">
          </div>

          <div class="col-md-2 ">
            <label>Order</label>
            <input class="form-control" maxlength="3" required v-model="course.OrderBy" onkeypress="return functionx(event)" />

          </div>
          <div class="col-md-8 ">
            <label>Question</label>
            <input class="form-control" maxlength="250" required v-model="course.ProformaQuestion" />
          </div>
          <div class="col-md-4 ">
            <label>Status</label>
            <select class="form-control" v-model="selected_status" id="ddlStatus" v-on:change="onchange()">
              <option value="0">True</option>
              <option value="1">False</option>
            </select>
          </div>
        </div>
      </div>

      <div class="card-footer" style="text-align: right">
        <!--<button v-if="course.QuestionID!=0" class="btn btn-success btn-rounded submit" v-on:click="Update(course.QuestionID),changeState('default')">Update</button>-->
        <button type="submit" class="btn btn-primary btn-rounded submit">Save</button>
        <button type="button" class="btn btn-danger clear-form btn-rounded btn-outline" v-on:click="cancel()">Cancel</button>
      </div>
    </div>
    <div class="page-content" v-if="state==='default'">
      <div class="card card-info">
        <div class="card-header with-border">
          Course Questions
          <button v-on:click="changeState('edit')" class="btn btn-primary btn-rounded float-right">New +</button>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 table-responsive">
              <table width="100%" class="table table-bordered table-striped">
                <thead class="bg-info">
                  <tr>
                    <th>Code</th>
                    <th>Order</th>
                    <th style="text-align: center">Questions</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in course_question">
                    <td>{{item.Code}}</td>
                    <td>{{item.OrderBy}}</td>
                    <td>{{item.ProformaQuestion}}</td>
                    <td v-if="item.ActiveStatus==true"><i class="fa fa-check" aria-hidden="true"></i></td>
                    <td v-else="item.ActiveStatus==false"><i class="fa fa-times" aria-hidden="true"></i></td>
                    <td>
                      <button type="button" class="btn btn-success" v-on:click="Edit(item.QuestionID)">Edit</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>


<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        course: { QuestionID: '0', Code: "", OrderBy: "", ProformaQuestion: "", ActiveStatus: "True" },
        selected_status: '0',
        course_question: [],
        state: 'default',
      }
    },
    created: function () {
      this.get_course_question();
    },
    mounted: function () {

    },
    updated: function () {
    },
    methods:
    {
      save: function (e) {
        e.preventDefault();
        startReq();
        var vm = this;
        axios.post('/api/QECApi/Savecoursequestion ', {
          obj: vm.course,
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success("Saved successfully");
              vm.get_course_question();
            }
            else {
              toastr.error("All fields required");
              vm.state = 'edit';
            }
            endReq();
            vm.cancel();
          })
          .then(function (error) {
            console.log(error);
          })
      },
      onchange() {
        this.course.ActiveStatus = $('#ddlStatus option:selected').text();
      },
      get_course_question() {
        startReq();
        var vm = this;
        axios.post('/api/QECApi/loadCourseQuestion')
          .then(function (res) {
            vm.course_question = res.data.record;
            console.log(res);
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      changeState: function (newState) {
        this.state = newState;
      },
      Edit(QuestionID) {
        startReq();
        var vm = this;
        axios.post('/api/QECApi/EditQuestion?QuestionID=' + QuestionID)
          .then(function (res) {
            if (res.data.status == true) {
              vm.course = res.data.record;
              //vm.selected_status = '1';
              vm.state = 'edit';
              endReq();
            }
            else {
              toastr.error(res.data.msg, 'Error!')
              //vm.selected_status = '0';
              endReq();
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      //Update(QuestionID) {
      //  startReq();
      //  var vm = this;
      //  axios.post('/api/QECApi/UpdateQuestion', {
      //    obj: vm.course,
      //    QuestionID: QuestionID,
      //  })
      //    .then(function (res) {

      //      var result = res.data.replace('{"d":null}', '');
      //      var dd = JSON.parse(result);

      //      if (dd == "Record Not Found") {
      //        toastr.error("All fields required");
      //        vm.state = 'edit';
      //      }
      //      else {
      //        if (dd == "Update") {
      //          toastr.success("Saved");
      //          endReq();
      //        }
      //        vm.get_course_question();
      //      }
      //      vm.clear();
      //    })
      //    .then(function (error) {
      //      console.log(error)
      //    })
      //},
      cancel() {
        window.location.reload();
      }
    }
  });
</script>



// WEBPACK FOOTER //
// src/components/QEC/coursequestionform.vue